import React, { ReactNode, useLayoutEffect, useRef } from 'react';
import styles from './Collapsible.module.scss';

export type CollapsibleProps = {
  dataTest?: string;
  expand?: boolean;
  children: ReactNode;
  onExpand?: () => void;
  onCollapse?: () => void;
};

export default function Collapsible({
  children,
  expand,
  dataTest,
  onExpand,
  onCollapse,
}: CollapsibleProps) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (expand && ref.current) {
      ref.current.style.height = `${ref.current.scrollHeight + 25}px`;
      onExpand && onExpand();
    } else if (!expand && ref.current) {
      ref.current.style.height = '0px';
      onCollapse && onCollapse();
    }
  }, [expand, onCollapse, onExpand]);

  return (
    <div data-test={dataTest} className={styles.container} ref={ref}>
      {children}
    </div>
  );
}
